import React from "react";
import { ChatItemMobile } from "./ChatItemMobile";
import { ReceivedMessage, SentMessage } from "./ChatItem";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { api, setAuthToken } from "../../../Components/functions/Api";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getTime,
  getDay,
  isRentalActive,
  getProfileFromWallet,
  isSameWalletAddress,
  isSameChatMessage,
  dedupeChatMessages,
} from "../../../Components/functions/Functions";
import { setMessageToSend, setReceivedMessage } from "../../../ReduxSlices/CommunicationSlice";
import { removeItem } from "../../../ReduxSlices/NotificationSlice";
import { toast } from "react-toastify";
import { ProfileRequiredModal } from "../../../Components/Rent/ProfileRequiredModal";
import Messages from "../../../assets/Dashboardsvg/Messages";
import Dashboardsearch from "../../../assets/Dashboardsvg/Dashboardsearch";
import TypeMessage from "../../../assets/Dashboardsvg/TypeMessage";
import TypeSearch from "../../../assets/Dashboardsvg/TypeSearch";
import SendMessage from "../../../assets/Dashboardsvg/SendMessage";
import { MessagesInboxIcon } from "../../../AssetComponents/Images";

export const InboxMobile = ({ mode }) => {
  const ref = useRef(null);
  const inputRef = useRef(null);
  const [text, setText] = useState("");
  const [time, setTime] = useState(null);
  const location = useLocation();
  const account = useSelector((state) => state.auth.account);
  const myProfile = useSelector((state) => state.auth.profile);
  const notificationItems = useSelector((state) => state.notification.items);
  const [chats, setChats] = useState([]);
  const [messages, setMessages] = useState([]);
  const [chat, setChat] = useState();
  const [receiver, setReceiver] = useState();
  const [receiverProfile, setReceiverProfile] = useState();
  const [nftId, setNftId] = useState();
  const [currentView, setCurrentView] = useState('list');
  const [searchQuery, setSearchQuery] = useState('');
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const fileInputRef = useRef(null);
  const prevChatParamRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const receivedMessage = useSelector((state) => state.communication.receivedMessage);

  useEffect(() => {
    if (!receivedMessage) return;

    console.log("🔥 Mobile: Received real-time message:", receivedMessage);

    const isEcho = receivedMessage._isEcho === true;
    const isFromSelf =
      isSameWalletAddress(receivedMessage.message?.sender, account) ||
      receivedMessage.message.sender === account;
    
    // 🔥 CRITICAL FIX: Use loose equality and string comparison to handle ID mismatches
    // Also check if chat is null/undefined and we should still add the message
    const chatIdMatches = receivedMessage.id === chat || 
                          String(receivedMessage.id) === String(chat) ||
                          receivedMessage.id == chat; // Loose equality as fallback
    
    // 🔥 CRITICAL FIX: Update chat ID if we receive a message with a new chat ID (from self)
    // This ensures subsequent messages use the correct chat ID when a new chat is created
    if (isFromSelf && receivedMessage.id && (!chat || String(chat) !== String(receivedMessage.id))) {
      console.log("🆕 Mobile: Updating chat ID from received message:", {
        oldChat: chat,
        newChat: receivedMessage.id
      });
      setChat(receivedMessage.id);
    }
    
    // 🔥 FIX: ONLY add to current chat if it matches, including messages from self
    // Also add if chat is null and this is from self (new chat being created)
    const shouldAddMessage = chatIdMatches || (isFromSelf && !chat && receivedMessage.id);
    
    if (shouldAddMessage) {
      console.log(`✅ Mobile: Adding received message to current chat (from self: ${isFromSelf})`);
      console.log("📝 Mobile: Message details:", {
        hasText: !!receivedMessage.message.text,
        hasImage: !!receivedMessage.message.image,
        messageType: receivedMessage.message.messageType,
      });
      
      setMessages((prevMessages) => {
        const incoming = receivedMessage.message;
        const exists = prevMessages.some((msg) => isSameChatMessage(msg, incoming));
        if (exists) {
          console.log("🔄 Mobile: Exact duplicate found, ignoring");
          return prevMessages;
        }
        return dedupeChatMessages([...prevMessages, incoming]);
      });
      
      setTime(receivedMessage.message.generatedTime);
    } else {
      console.log("⚠️ Mobile: Message not added - chat ID mismatch:", {
        receivedId: receivedMessage.id,
        currentChat: chat,
        isFromSelf: isFromSelf,
        hasChat: !!chat,
        chatIdMatches: chatIdMatches
      });
    }

    if (!isEcho && !isFromSelf) {
      const receivedId = String(receivedMessage.id || "");
      const matchingChat = chats.find((item) => {
        const itemId = String(item.chatId || "");
        return itemId === receivedId || item.chatId == receivedMessage.id;
      });

      if (matchingChat) {
        setChats((prevChats) => {
          return prevChats
            .map((chatItem) => {
              const chatItemId = String(chatItem.chatId || "");
              const isMatching =
                chatItemId === receivedId || chatItem.chatId == receivedMessage.id;
              if (isMatching) {
                const isCurrentChat =
                  String(chat || "") === receivedId || chat == receivedMessage.id;
                return {
                  ...chatItem,
                  latestMessageTime: receivedMessage.message.generatedTime,
                  unreadMessages: !isCurrentChat
                    ? (chatItem.unreadMessages || 0) + 1
                    : chatItem.unreadMessages || 0,
                };
              }
              return chatItem;
            })
            .sort((a, b) => {
              const timeA = new Date(a.latestMessageTime).getTime();
              const timeB = new Date(b.latestMessageTime).getTime();
              
              // Handle invalid dates
              if (isNaN(timeA) && isNaN(timeB)) return 0;
              if (isNaN(timeA)) return 1;
              if (isNaN(timeB)) return -1;
              
              // Sort in descending order (newest first)
              return timeB - timeA;
            });
        });
      } else {
        // New chat not in list yet — refresh chats
        getChats();
      }
    }

    dispatch(setReceivedMessage(null));
  }, [receivedMessage, chat, account, mode, dispatch, chats]);

  const sendMessage = async () => {
    if (!myProfile) {
      setShowProfileModal(true);
      return;
    }
    
    // Debug logging
    console.log("📤 Send message attempt:", {
      receiver,
      nftId,
      text: text?.length,
      hasImage: !!selectedImage,
      myProfile: !!myProfile
    });
    
    if (!receiver || !nftId) {
      console.log("❌ Send message blocked:", {
        hasReceiver: !!receiver,
        hasNftId: !!nftId,
        hasText: !!text,
        hasImage: !!selectedImage
      });
      return;
    }

    // Check if message has content
    if (!text?.trim() && !selectedImage) {
      return;
    }

    let textToSend = text?.trim() || "";
    let imageUrl = null;

    // Upload image if selected
    if (selectedImage) {
      try {
        imageUrl = await uploadImageToPinata(selectedImage.file);
      } catch (error) {
        console.error("Failed to upload image:", error);
        return; // Don't send message if image upload fails
      }
    }

    const generatedTime = new Date();
    const messageTimeString = generatedTime.toISOString();

    // Determine message type
    const messageType = textToSend && imageUrl ? "text_image" : 
                       imageUrl ? "image" : "text";

    const MessageObj = {
      sender: account,
      generatedTime: messageTimeString,
      text: textToSend,
      image: imageUrl,
      messageType: messageType,
    };

    const sendingData = {
      id: chat, // This will be null for new conversations
      newMessage: MessageObj,
      sender: account,
      receiver: receiver,
      owner: receiver, // The receiver is the property owner
      nftId: nftId,
      propertyId: nftId, // Add property identifier for consistency
      mode: mode === "traveler" || mode === "host" ? "short" : "long",
      // Add unique chat identifier to prevent duplicates
      chatIdentifier: `${Math.min(account, receiver)}_${Math.max(account, receiver)}_${nftId}_${mode}`,
    };

    console.log("🚀 Mobile: Sending message with data:", sendingData);
    
    dispatch(setMessageToSend(sendingData));
    setMessages((prevMessages) =>
      dedupeChatMessages([...prevMessages, MessageObj])
    );
    setTime(messageTimeString);
    setText("");
    setSelectedImage(null); // Clear selected image
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    // Message is dispatched via socket-first flow (with centralized HTTP fallback in App.js).
    // No direct HTTP call here to avoid duplicate deliveries.
  };

  const getChats = async () => {
    if (!account) return;

    try {
      const res = await api("user/inbox", { account: account });
      if (res && Array.isArray(res)) {
        const sortedChats = [...res].sort((a, b) => {
          const timeA = new Date(a.latestMessageTime).getTime();
          const timeB = new Date(b.latestMessageTime).getTime();
          
          // Handle invalid dates
          if (isNaN(timeA) && isNaN(timeB)) return 0;
          if (isNaN(timeA)) return 1;
          if (isNaN(timeB)) return -1;
          
          // Sort in descending order (newest first)
          return timeB - timeA;
        });
        setChats(sortedChats);
      }
    } catch (error) {
      console.error("Failed to fetch chats:", error);
    }
  };

  useEffect(() => {
    // Immediate force refresh on mount when account available
    getChats();
    // 🔥 OPTIMIZATION: Increased refresh interval from 30s to 60s
    const interval = setInterval(() => getChats(), 60000); // 60 seconds instead of 30
    return () => clearInterval(interval);
  }, [account]);

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    const urlChat = sp.get("chat");
    if (urlChat && urlChat !== prevChatParamRef.current) {
      prevChatParamRef.current = urlChat;
      dispatch(setReceivedMessage(null));
    }
    if (!urlChat) prevChatParamRef.current = null;
  }, [location.search, dispatch]);

  // 🔥 OPTIMIZATION: Debounce focus/visibility refresh
  useEffect(() => {
    let focusTimeout;
    let visibilityTimeout;
    
    const handleFocus = () => {
      clearTimeout(focusTimeout);
      focusTimeout = setTimeout(() => {
        if (account) getChats();
      }, 500); // Debounce 500ms
    };
    
    const handleVisibility = () => {
      clearTimeout(visibilityTimeout);
      visibilityTimeout = setTimeout(() => {
        if (document.visibilityState === 'visible' && account) {
          getChats();
        }
      }, 500); // Debounce 500ms
    };
    
    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibility);
    
    return () => {
      clearTimeout(focusTimeout);
      clearTimeout(visibilityTimeout);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [account]);

  // Handle URL parameters for new chat initialization
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const newChat = searchParams.get("chat");
    const newNftId = searchParams.get("id");
    const newReceiver = searchParams.get("receiver");

    console.log("🔄 Mobile Inbox - Location search changed:", {
      newChat,
      newNftId,
      newReceiver,
      currentChat: chat,
      currentNftId: nftId,
      currentReceiver: receiver,
    });

    // If there's a chat parameter, open that chat
    if (newChat && newChat !== chat) {
      console.log("🔗 Mobile: Setting chat from URL:", newChat);
      // 🔥 CRITICAL FIX: Load chat info FIRST before setting chat
      // This ensures receiver/nftId are available immediately for real-time messaging
      const loadChatInfoImmediately = async () => {
        try {
          const res = await api("chat/getChattingInfo", {
            id: newChat,
            reader: account,
          });
          if (res) {
            console.log("✅ Mobile: Chat info loaded immediately:", {
              receiver: res.receiver,
              nftId: res.nftId,
            });
            // Set receiver and nftId BEFORE setting chat to ensure real-time messaging works
            if (res.receiver) {
              setReceiver(res.receiver);
              // Load receiver profile
              getProfileFromWallet(res.receiver).then(profile => {
                console.log("✅ Mobile: Receiver profile loaded:", profile);
                setReceiverProfile(profile);
              }).catch(error => {
                console.error("❌ Mobile: Failed to load receiver profile:", error);
                setReceiverProfile(null);
              });
            }
            if (res.nftId && res.nftId !== 'undefined' && res.nftId !== 'null') {
              setNftId(res.nftId);
            } else {
              setNftId(null);
            }
            // Now set chat and view - receiver/nftId are already loaded
            setChat(newChat);
            setCurrentView('chat');
          } else {
            // Fallback: set chat even if info fails to load
            setChat(newChat);
            setCurrentView('chat');
            setNftId(null);
            setReceiver(null);
          }
        } catch (error) {
          console.error("Mobile: Error loading chat info:", error);
          // Fallback: set chat even if info fails to load
          setChat(newChat);
          setCurrentView('chat');
          setNftId(null);
          setReceiver(null);
        }
      };
      
      if (account) {
        loadChatInfoImmediately();
      } else {
        // If no account, just set chat
        setChat(newChat);
        setCurrentView('chat');
        setNftId(null);
        setReceiver(null);
      }
      
      setTime(null);
    } else if (newNftId && newReceiver && (!chat || nftId !== newNftId || receiver !== newReceiver)) {
      console.log("🆕 Mobile: Initializing new chat from URL params", {
        newNftId,
        newReceiver,
        currentNftId: nftId,
        currentReceiver: receiver
      });
      
      setNftId(newNftId);
      setChat(null);
      setTime(null);
      setCurrentView('chat');

      // Resolve receiver to preferred address (EVM when reader is EVM) for profile/chat compatibility
      const loadAndFindChat = async () => {
        try {
          const resolved = await api("chat/resolveReceiver", {
            receiver: newReceiver,
            reader: account || newReceiver,
          });
          const resolvedReceiver = resolved?.receiver ?? newReceiver;
          setReceiver(resolvedReceiver);
          getProfileFromWallet(resolvedReceiver).then(profile => {
            setReceiverProfile(profile);
          }).catch(() => setReceiverProfile(null));

          if (account) {
            const { getChatId } = await import("../../../Components/functions/Functions");
            const existingChatId = await getChatId(
              account,
              resolvedReceiver,
              newNftId,
              "short"
            );
            if (existingChatId) {
              setChat(existingChatId);
              const sp = new URLSearchParams(location.search);
              sp.set("chat", existingChatId);
              sp.delete("id");
              sp.delete("receiver");
              navigate(location.pathname + `?${sp.toString()}`);
            } else {
              setMessages([]);
            }
          }
        } catch (error) {
          console.error("Mobile: Error resolving receiver or finding chat:", error);
          setReceiver(newReceiver);
          getProfileFromWallet(newReceiver).then(setReceiverProfile).catch(() => setReceiverProfile(null));
          setMessages([]);
          if (account) {
            try {
              const { getChatId } = await import("../../../Components/functions/Functions");
              const existingChatId = await getChatId(account, newReceiver, newNftId, "short");
              if (existingChatId) {
                setChat(existingChatId);
                const sp = new URLSearchParams(location.search);
                sp.set("chat", existingChatId);
                sp.delete("id");
                sp.delete("receiver");
                navigate(location.pathname + `?${sp.toString()}`);
              }
            } catch (e) {
              setMessages([]);
            }
          }
        }
      };

      if (account) {
        loadAndFindChat();
      } else {
        setReceiver(newReceiver);
        getProfileFromWallet(newReceiver).then(setReceiverProfile).catch(() => setReceiverProfile(null));
      }
    } else {
      console.log("⚠️ Mobile: No action taken for URL params", {
        newNftId,
        newReceiver,
        hasChat: !!chat,
        currentNftId: nftId,
        currentReceiver: receiver
      });
    }
  }, [location.search, chat, nftId, receiver, account]);

  const getMessages = async (forceRefresh = false, loadMore = false) => {
    if (!chat || !account) return;

    try {
      // 🔥 OPTIMIZATION: Only clear cache if it's a force refresh and not loading more
      if (forceRefresh && !loadMore) {
        const cacheKey = `chat/getMessages-${JSON.stringify({ id: chat, reader: account })}`;
        sessionStorage.removeItem(cacheKey);
      }
      
      // 🔥 NEW: Pagination support - get oldest message time if loading more
      const oldestMessage = loadMore && messages.length > 0 
        ? messages[0].generatedTime 
        : null;
      
      const res = await api("chat/getMessages", {
        id: chat,
        reader: account,
        limit: 50, // Load last 50 messages initially
        before: oldestMessage, // For pagination
      });

      if (res && res.chattingSession) {
        const backendMessages = res.chattingSession.messages || [];
        
        // 🔥 FIXED: Ensure all messages have properly encoded Unicode text
        const sanitizedBackendMessages = backendMessages.map((msg) => ({
          sender: String(msg.sender),
          generatedTime: msg.generatedTime,
          text: String(msg.text || ''), // 🔥 Ensure Unicode is preserved
          image: msg.image ? String(msg.image) : null, // 🔥 NEW: Include image URL
          messageType: msg.messageType || "text", // 🔥 NEW: Include message type
        }));

        // 🔥 CRITICAL FIX: Log ALL sanitized messages to verify emojis
        console.log("🔍 Mobile: ALL SANITIZED MESSAGES (with emojis check):");
        sanitizedBackendMessages.forEach((msg, idx) => {
          const hasEmoji = /[\u{1F300}-\u{1F9FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/u.test(msg.text);
          console.log(`  Mobile Message ${idx}: "${msg.text.substring(0, 50)}" - Has emoji: ${hasEmoji}`);
        });

        // Log to verify emojis are present
        if (sanitizedBackendMessages.length > 0) {
          console.log("📝 Mobile: First message text (first 50 chars):", sanitizedBackendMessages[0]?.text?.substring(0, 50));
          console.log("📝 Mobile: Last message text (first 50 chars):", sanitizedBackendMessages[sanitizedBackendMessages.length - 1]?.text?.substring(0, 50));
        }

        // 🔥 OPTIMIZATION: If loading more, prepend messages; otherwise replace
        const finalMessages = sanitizedBackendMessages.map((msg) => ({
          sender: String(msg.sender),
          generatedTime: msg.generatedTime,
          text: String(msg.text || ''),
          image: msg.image ? String(msg.image) : null,
          messageType: msg.messageType || "text",
        }));

        console.log("✅ Mobile: Setting final messages (count):", finalMessages.length);
        
        if (loadMore && messages.length > 0) {
          const combined = [...finalMessages, ...messages];
          setMessages(dedupeChatMessages(combined));
        } else {
          setMessages(dedupeChatMessages(finalMessages));
        }
        
        setTime(finalMessages.length > 0 ? finalMessages[finalMessages.length - 1]?.generatedTime : null);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  useEffect(() => {
    if (chat && account) {
      getMessages(true);
    }
  }, [chat, account]);

  // 🔥 OPTIMIZATION: Reduced periodic refresh from 2min to 5min (socket handles real-time)
  useEffect(() => {
    if (!chat || !account) return;
    const interval = setInterval(() => {
      console.log("🔄 Mobile: Periodic message refresh (fallback) for chat:", chat);
      getMessages(true);
    }, 300000); // 5 minutes instead of 2
    return () => clearInterval(interval);
  }, [chat, account]);

  // 🔥 NEW: Get chat info (receiver, nftId) from chat ID when chat is selected from URL
  const getChattingInfo = async () => {
    if (!chat || !account) {
      console.log("❌ Mobile: Missing chat or account for getChattingInfo");
      return;
    }

    try {
      console.log("🔄 Mobile: Getting chatting info for chat:", chat);
      const res = await api("chat/getChattingInfo", {
        id: chat,
        reader: account,
      });

      if (res) {
        console.log("✅ Mobile: Chatting info received:", {
          receiver: res.receiver,
          nftId: res.nftId,
        });

        // Set receiver and nftId from chat info
        if (res.receiver) {
          setReceiver(res.receiver);
          // Load receiver profile
          getProfileFromWallet(res.receiver).then(profile => {
            console.log("✅ Mobile: Receiver profile loaded:", profile);
            setReceiverProfile(profile);
          }).catch(error => {
            console.error("❌ Mobile: Failed to load receiver profile:", error);
            setReceiverProfile(null);
          });
        }

        if (res.nftId && res.nftId !== 'undefined' && res.nftId !== 'null') {
          setNftId(res.nftId);
        } else {
          setNftId(null);
        }
      } else {
        console.log("❌ Mobile: No response from getChattingInfo");
      }
    } catch (error) {
      console.error("💥 Mobile: Error getting chatting info:", error);
    }
  };

  // 🔥 NEW: Load chat info when chat is selected from URL
  useEffect(() => {
    if (chat && account) {
      // Only fetch if we don't have receiver yet (chat loaded from URL)
      // This prevents unnecessary calls when receiver is already set
      const searchParams = new URLSearchParams(location.search);
      const urlChat = searchParams.get("chat");
      if (urlChat === chat && !receiver) {
        console.log("🔄 Mobile: Chat selected from URL, loading chat info...");
        getChattingInfo();
      }
    }
  }, [chat, account, location.search]);

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, [messages.length]);

  // Smooth auto-scroll anchor
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    try {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    } catch (e) {}
  };
  useEffect(() => {
    scrollToBottom();
  }, [messages.length, messages]);

  const handleChatSelect = (chatId, receiverAddress, nftId, profile) => {
    setChat(chatId);
    setReceiver(receiverAddress);
    setNftId(nftId);
    setReceiverProfile(profile);
    setCurrentView('chat');
    
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("chat", chatId);
    navigate(location.pathname + `?${searchParams.toString()}`);
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setChat(null);
    setReceiver(null);
    setNftId(null);
    setReceiverProfile(null);
    setMessages([]);
    
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("chat");
    navigate(location.pathname + `?${searchParams.toString()}`);
  };

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  // Simple emoji support
  const EMOJIS = [
    "😀","😁","😂","🤣","😊","😍","😘","😅","😉","😎",
    "🤔","🙄","😇","🙌","👍","🙏","👏","💯","🔥","🌟",
    "💜","🎉","✨","🥳","🤝","🤩","😌","😢","😭","😤"
  ];
  const addEmoji = (emoji) => {
    setText((prev) => (prev || "") + emoji);
    setTimeout(() => {
      try { inputRef.current?.focus(); } catch (e) {}
    }, 0);
  };

  // Image upload handler
  const handleImageSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.error('Please select an image file');
      return;
    }

    // Validate file size (10MB limit)
    if (file.size > 10 * 1024 * 1024) {
      toast.error('Image size must be less than 10MB');
      return;
    }

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage({
        file: file,
        preview: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  const uploadImageToPinata = async (file) => {
    try {
      setUploadingImage(true);
      const formData = new FormData();
      formData.append('image', file);

      const response = await fetch(`${process.env.REACT_APP_BACKEND_SERVER}chat/uploadImage`, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: setAuthToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to upload image');
      }

      const data = await response.json();
      console.log('✅ Mobile: Image uploaded to Pinata:', data.imageUrl);
      return data.imageUrl;
    } catch (error) {
      console.error('❌ Mobile: Error uploading image:', error);
      toast.error('Failed to upload image');
      throw error;
    } finally {
      setUploadingImage(false);
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const filteredChats = chats.filter((item) => item.mode === mode);

  // Debug current state
  console.log("🔍 Mobile Inbox Current State:", {
    receiver,
    nftId,
    chat,
    currentView,
    messagesCount: messages.length,
    hasText: !!text?.trim(),
    canSend: !!(receiver && nftId && text?.trim()),
    receiverType: typeof receiver,
    nftIdType: typeof nftId,
    receiverLength: receiver?.length,
    nftIdLength: nftId?.length,
    receiverTruthy: !!receiver,
    nftIdTruthy: !!nftId,
    inputDisabled: !receiver || !nftId
  });

  const renderChatList = () => (
    <div className="w-full h-full flex flex-col">
      <div className="flex items-center gap-[6px] p-[8px] border-b border-[#E3E3E3] bg-white flex-shrink-0">
        <div className="scale-75">
          <MessagesInboxIcon />
        </div>
        <div className="text-[18px] font-semibold">Messages</div>
      </div>

      <div className="p-[8px] border-b border-[#E3E3E3] bg-white flex-shrink-0">
        <div className="flex gap-[8px] items-center border-[#E3E3E3] border-[1px] rounded-[12px] pl-[12px] pr-[6px] py-[8px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
          <div className="scale-75">
            <Messages />
          </div>
          <input 
            placeholder="Search" 
            className="w-full outline-none text-sm"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="scale-75">
            <Dashboardsearch />
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-[8px] space-y-[8px] min-h-0">
        {filteredChats.length > 0 ? (
          filteredChats.map((item, index) => (
            <div key={`chat-${item.chatId}-${index}`}>
              <ChatItemMobile
                myChatId={item.chatId}
                mode={mode}
                time={item.chatId === chat ? time : null}
                setNft={setNftId}
                setReceiver={setReceiver}
                setReceiverProfile={setReceiverProfile}
                onChatSelect={handleChatSelect}
              />
            </div>
          ))
                 ) : (
           <div className="flex flex-col items-center justify-center h-full text-center p-3">
             <div className="text-base font-medium text-gray-600 mb-2">No messages yet</div>
             <div className="text-xs text-gray-500 mb-4">
               Start a conversation to see your messages here
             </div>
             
             {/* Check if we have URL params for new conversation */}
             {(() => {
               const searchParams = new URLSearchParams(location.search);
               const hasNewConversationParams = searchParams.get("id") && searchParams.get("receiver");
               
               if (hasNewConversationParams) {
                 return (
                   <div className="text-xs text-purple-600 font-medium">
                     New conversation ready - check the chat view below
                   </div>
                 );
               }
               
               return (
                 <div className="text-xs text-gray-400">
                   Contact a host from a property listing to start chatting
                 </div>
               );
             })()}
           </div>
         )}
      </div>
    </div>
  );

  const renderChatView = () => (
    <div className="w-full h-full flex flex-col">
      {/* Only show header when a chat is selected */}
      {(receiver || chat) && (
        <div className="flex items-center gap-[8px] p-[8px] border-b border-[#E3E3E3] bg-white flex-shrink-0">
          <button
            onClick={handleBackToList}
            className="p-[6px] rounded-full hover:bg-gray-100"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="#5b1dee" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          
          {receiverProfile && (
            <div className="p-[2px] w-[36px] h-[36px] rounded-full bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee00]">
              <img
                alt=""
                className="w-full h-full rounded-full object-cover"
                src={receiverProfile?.Avatar}
              />
            </div>
          )}
          <div className="text-[16px] font-medium truncate flex-1">
            {receiverProfile?.Name?.replace("/", " ") || "Loading..."}
          </div>
        </div>
      )}

      <div ref={ref} className="flex-1 p-[6px] overflow-auto bg-[#F6F6F6] min-h-0 relative">
        {!receiver && !chat ? (
          // Show empty state when no chat is selected
          <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
            <div className="rounded-md bg-white p-6 text-center max-w-sm">
              <div className="text-base font-medium text-gray-700 mb-2">
                No messages yet
              </div>
              <div className="font-normal text-sm text-gray-500">
                Select a chat from the list to start messaging
              </div>
            </div>
          </div>
        ) : (
          messages.map((message, i) => {
          let messageTime;
          try {
            messageTime = new Date(message.generatedTime);
            if (isNaN(messageTime.getTime())) {
              messageTime = new Date();
            }
          } catch (error) {
            messageTime = new Date();
          }

          return (
            <React.Fragment key={`${message.sender}-${message.text}-${i}-${message.generatedTime}`}>
              <div className="w-full text-center text-[#B6B6B6] my-[10px] text-sm">
                {i === 0 ? getDay(messageTime) : 
                  (() => {
                    let prevMessageTime;
                    try {
                      prevMessageTime = new Date(messages[i - 1].generatedTime);
                      if (isNaN(prevMessageTime.getTime())) {
                        prevMessageTime = new Date();
                      }
                    } catch (error) {
                      prevMessageTime = new Date();
                    }
                    return getDay(messageTime) !== getDay(prevMessageTime) ? getDay(messageTime) : null;
                  })()
                }
              </div>

              {(() => {
                // 🔥 FIX: Use defensive checks for sender comparison to handle type mismatches
                const messageSender = String(message.sender || '');
                const currentAccount = String(account || '');
                const isSentMessage =
                  isSameWalletAddress(message.sender, account) ||
                  messageSender === currentAccount ||
                  message.sender == account;
                
                return isSentMessage ? (
                  <SentMessage 
                    text={message.text} 
                    image={message.image}
                    messageType={message.messageType}
                    time={getTime(messageTime)} 
                  />
                ) : (
                  <ReceivedMessage 
                    text={message.text} 
                    image={message.image}
                    messageType={message.messageType}
                    time={getTime(messageTime)} 
                  />
                );
              })()}
            </React.Fragment>
          );
        })
        )}
        <div ref={messagesEndRef} />
        {receiver && messages.length === 0 && (
          <div className="absolute top-0 left-0 w-full h-[calc(100%-80px)] bg-[#B2B2B2A0] flex flex-col items-center justify-center p-3">
            <div className="rounded-md bg-white p-4 text-center max-w-sm">
              <div className="text-sm font-medium mb-2">Start a conversation</div>
              <div className="font-normal text-xs text-gray-600 mb-3">
                Send a message to chat with{" "}
                <div className="font-medium text-gray-900">
                  {receiverProfile?.Name?.replace("/", " ") || "the host"}
                </div>
              </div>
              <div className="text-xs text-gray-500">
                Type your message below to begin
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Only show message input when a chat is selected */}
      {(receiver || chat) && (
             <div className="flex w-full px-[12px] gap-[12px] p-[8px] bg-white border-t border-[#E3E3E3] flex-shrink-0">
        <div className="gap-[8px] rounded-[12px] flex items-center px-[10px] py-[8px] w-full bg-white shadow-md shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] relative">
           <div
             className="scale-75 cursor-pointer select-none"
             role="button"
             aria-label="Open emoji picker"
             onClick={() => setShowEmojiPicker(s => !s)}
           >
             <TypeMessage />
           </div>
           <input
             placeholder={receiver && nftId ? "Type Message.." : "Loading conversation..."}
             className="w-full outline-none text-sm"
             onChange={(e) => {
               console.log("📝 Input onChange triggered:", e.target.value);
               setText(e.target.value);
             }}
             value={text}
             onKeyDown={handleEnterKey}
             onFocus={() => console.log("🎯 Input focused")}
             onBlur={() => console.log("👋 Input blurred")}
             disabled={false}
             autoFocus={false}
             ref={inputRef}
           />
           {/* Hidden file input */}
           <input
             type="file"
             accept="image/*"
             ref={fileInputRef}
             onChange={handleImageSelect}
             className="hidden"
           />
           <div
             className="scale-75 cursor-pointer select-none"
             role="button"
             aria-label="Upload image"
             onClick={() => fileInputRef.current?.click()}
           >
             <TypeSearch />
           </div>
           {/* Image preview */}
           {selectedImage && (
             <div className="absolute bottom-[52px] left-[10px] bg-white border border-[#E3E3E3] rounded-[10px] p-2 shadow-lg z-10 max-w-[200px]">
               <div className="relative">
                 <img
                   src={selectedImage.preview}
                   alt="Preview"
                   className="rounded-[8px] w-full max-h-[150px] object-cover"
                 />
                 <button
                   onClick={removeSelectedImage}
                   className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-[20px] h-[20px] flex items-center justify-center text-xs hover:bg-red-600"
                   aria-label="Remove image"
                 >
                   ×
                 </button>
               </div>
               {uploadingImage && (
                 <div className="text-xs text-gray-500 mt-2 text-center">Uploading...</div>
               )}
             </div>
           )}
          {showEmojiPicker && (
            <div className="absolute bottom-[52px] left-[10px] bg-white border border-[#E3E3E3] rounded-[10px] p-2 shadow-lg w-[220px] max-h-[200px] overflow-auto z-10">
              <div className="grid grid-cols-8 gap-1 text-xl">
                {EMOJIS.map((emj, idx) => (
                  <button
                    key={`m-emoji-${idx}`}
                    className="hover:bg-[#f3f3f3] rounded p-[2px]"
                    onClick={() => addEmoji(emj)}
                  >
                    {emj}
                  </button>
                ))}
              </div>
            </div>
          )}
         </div>
         <div
           className={`p-[12px] cursor-pointer text-white shadow-[-1px_3px_3px_0_rgba(80,80,80,0.2)] rounded-[12px] font-semibold transition-all duration-200 ${
             text?.trim()
               ? "bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee] hover:shadow-[-1px_6px_10px_0_rgba(93,0,207,0.5)] hover:-translate-y-[3px]"
               : "bg-gray-400 cursor-not-allowed"
           }`}
           onClick={text?.trim() ? sendMessage : undefined}
         >
           <div className="scale-75">
             <SendMessage />
           </div>
         </div>
       </div>
       )}
    </div>
  );

  // If we have receiver and nftId from URL params, always show chat view
  const shouldShowChatView = currentView === 'chat' || (receiver && nftId);
  
  console.log("🎯 Mobile View Decision:", {
    currentView,
    receiver: !!receiver,
    nftId: !!nftId,
    shouldShowChatView,
    hasURLParams: !!(new URLSearchParams(location.search).get("id") && new URLSearchParams(location.search).get("receiver"))
  });

  return (
    <div className="w-full h-[calc(100vh-70px)]">
      {shouldShowChatView ? renderChatView() : renderChatList()}
      
      <ProfileRequiredModal
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
        onCreateProfile={() => {
          setShowProfileModal(false);
          navigate("/dashboard/profile?mode=traveler");
        }}
        action="send messages"
      />
    </div>
  );
};
